import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

export default {
  install: app => {
    app.component('Multiselect', Multiselect)
  }
}
